// AIRLINEOPS - GLOBAL AIRPORT DATABASE
// 171 Airports Worldwide - Full Global Coverage
// Covers: All major international hubs + US domestic network
// Regions: North America, Europe, Asia, Middle East, Africa, Oceania, Caribbean

// Import full airport database for global routes
import { AIRPORTS as FULL_AIRPORTS } from "../systems/AirportDatabase.js";
// Import global airports database (~4800 airports) for user-created routes
import { GLOBAL_AIRPORTS } from "./GlobalAirports.js";

export const AIRPORTS = {
  // ============================================================================
  // LARGE HUBS (Top 15)
  // ============================================================================

  KATL: { 
    icao: "KATL", iata: "ATL", name: "Hartsfield-Jackson Atlanta Intl", 
    city: "Atlanta", state: "GA", lat: 33.6407, lon: -84.4277,
    hubSize: "large", runwayLength: 12390, slotCostMult: 3.0,
    noiseRestrictions: "none", international: true
  },
  KDFW: { 
    icao: "KDFW", iata: "DFW", name: "Dallas Fort Worth Intl", 
    city: "Dallas", state: "TX", lat: 32.8998, lon: -97.0403,
    hubSize: "large", runwayLength: 13401, slotCostMult: 2.8,
    noiseRestrictions: "none", international: true
  },
  KDEN: { 
    icao: "KDEN", iata: "DEN", name: "Denver Intl", 
    city: "Denver", state: "CO", lat: 39.8561, lon: -104.674,
    hubSize: "large", runwayLength: 16000, slotCostMult: 2.5,
    noiseRestrictions: "none", international: true
  },
  KORD: { 
    icao: "KORD", iata: "ORD", name: "Chicago O'Hare Intl", 
    city: "Chicago", state: "IL", lat: 41.9742, lon: -87.9073,
    hubSize: "large", runwayLength: 13000, slotCostMult: 3.5,
    noiseRestrictions: "night_curfew", international: true
  },
  KLAX: { 
    icao: "KLAX", iata: "LAX", name: "Los Angeles Intl", 
    city: "Los Angeles", state: "CA", lat: 33.9425, lon: -118.408,
    hubSize: "large", runwayLength: 12091, slotCostMult: 3.2,
    noiseRestrictions: "night_curfew", international: true
  },
  KJFK: { 
    icao: "KJFK", iata: "JFK", name: "John F Kennedy Intl", 
    city: "New York", state: "NY", lat: 40.6413, lon: -73.7781,
    hubSize: "large", runwayLength: 14511, slotCostMult: 4.0,
    noiseRestrictions: "strict", international: true
  },
  KSFO: { 
    icao: "KSFO", iata: "SFO", name: "San Francisco Intl", 
    city: "San Francisco", state: "CA", lat: 37.6213, lon: -122.379,
    hubSize: "large", runwayLength: 11870, slotCostMult: 3.0,
    noiseRestrictions: "night_curfew", international: true
  },
  KSEA: { 
    icao: "KSEA", iata: "SEA", name: "Seattle-Tacoma Intl", 
    city: "Seattle", state: "WA", lat: 47.4502, lon: -122.309,
    hubSize: "large", runwayLength: 11901, slotCostMult: 2.5,
    noiseRestrictions: "night_curfew", international: true
  },
  KLAS: { 
    icao: "KLAS", iata: "LAS", name: "Harry Reid Intl", 
    city: "Las Vegas", state: "NV", lat: 36.084, lon: -115.152,
    hubSize: "large", runwayLength: 14510, slotCostMult: 2.2,
    noiseRestrictions: "none", international: true
  },
  KMCO: { 
    icao: "KMCO", iata: "MCO", name: "Orlando Intl", 
    city: "Orlando", state: "FL", lat: 28.4312, lon: -81.3081,
    hubSize: "large", runwayLength: 12005, slotCostMult: 2.0,
    noiseRestrictions: "none", international: true
  },
  KEWR: { 
    icao: "KEWR", iata: "EWR", name: "Newark Liberty Intl", 
    city: "Newark", state: "NJ", lat: 40.6895, lon: -74.1745,
    hubSize: "large", runwayLength: 11000, slotCostMult: 3.5,
    noiseRestrictions: "strict", international: true
  },
  KMIA: { 
    icao: "KMIA", iata: "MIA", name: "Miami Intl", 
    city: "Miami", state: "FL", lat: 25.7959, lon: -80.287,
    hubSize: "large", runwayLength: 13000, slotCostMult: 2.8,
    noiseRestrictions: "night_curfew", international: true
  },
  KPHX: { 
    icao: "KPHX", iata: "PHX", name: "Phoenix Sky Harbor Intl", 
    city: "Phoenix", state: "AZ", lat: 33.4352, lon: -112.008,
    hubSize: "large", runwayLength: 11489, slotCostMult: 2.0,
    noiseRestrictions: "none", international: true
  },
  KIAH: { 
    icao: "KIAH", iata: "IAH", name: "George Bush Intercontinental", 
    city: "Houston", state: "TX", lat: 29.9902, lon: -95.3368,
    hubSize: "large", runwayLength: 12001, slotCostMult: 2.5,
    noiseRestrictions: "none", international: true
  },
  KBOS: { 
    icao: "KBOS", iata: "BOS", name: "Boston Logan Intl", 
    city: "Boston", state: "MA", lat: 42.3656, lon: -71.0096,
    hubSize: "large", runwayLength: 10083, slotCostMult: 2.8,
    noiseRestrictions: "night_curfew", international: true
  },

  // ============================================================================
  // MEDIUM HUBS (15 airports)
  // ============================================================================

  KMSP: { 
    icao: "KMSP", iata: "MSP", name: "Minneapolis-St Paul Intl", 
    city: "Minneapolis", state: "MN", lat: 44.8848, lon: -93.2223,
    hubSize: "medium", runwayLength: 11006, slotCostMult: 1.8,
    noiseRestrictions: "night_curfew", international: true
  },
  KDTW: { 
    icao: "KDTW", iata: "DTW", name: "Detroit Metropolitan", 
    city: "Detroit", state: "MI", lat: 42.2124, lon: -83.3534,
    hubSize: "medium", runwayLength: 12003, slotCostMult: 1.8,
    noiseRestrictions: "none", international: true
  },
  KPHL: { 
    icao: "KPHL", iata: "PHL", name: "Philadelphia Intl", 
    city: "Philadelphia", state: "PA", lat: 39.8744, lon: -75.2424,
    hubSize: "medium", runwayLength: 10506, slotCostMult: 2.0,
    noiseRestrictions: "night_curfew", international: true
  },
  KLGA: { 
    icao: "KLGA", iata: "LGA", name: "LaGuardia", 
    city: "New York", state: "NY", lat: 40.7769, lon: -73.8740,
    hubSize: "medium", runwayLength: 7003, slotCostMult: 3.5,
    noiseRestrictions: "strict", international: false
  },
  KDCA: { 
    icao: "KDCA", iata: "DCA", name: "Ronald Reagan Washington National", 
    city: "Washington", state: "DC", lat: 38.8521, lon: -77.0377,
    hubSize: "medium", runwayLength: 7169, slotCostMult: 3.0,
    noiseRestrictions: "strict", international: false
  },
  KFLL: { 
    icao: "KFLL", iata: "FLL", name: "Fort Lauderdale-Hollywood Intl", 
    city: "Fort Lauderdale", state: "FL", lat: 26.0742, lon: -80.1506,
    hubSize: "medium", runwayLength: 9000, slotCostMult: 1.5,
    noiseRestrictions: "night_curfew", international: true
  },
  KSAN: { 
    icao: "KSAN", iata: "SAN", name: "San Diego Intl", 
    city: "San Diego", state: "CA", lat: 32.7336, lon: -117.190,
    hubSize: "medium", runwayLength: 9401, slotCostMult: 2.0,
    noiseRestrictions: "strict", international: true
  },
  KTPA: { 
    icao: "KTPA", iata: "TPA", name: "Tampa Intl", 
    city: "Tampa", state: "FL", lat: 27.9755, lon: -82.5332,
    hubSize: "medium", runwayLength: 11002, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },
  KAUS: { 
    icao: "KAUS", iata: "AUS", name: "Austin-Bergstrom Intl", 
    city: "Austin", state: "TX", lat: 30.1945, lon: -97.6699,
    hubSize: "medium", runwayLength: 12250, slotCostMult: 1.8,
    noiseRestrictions: "none", international: true
  },
  KBNA: { 
    icao: "KBNA", iata: "BNA", name: "Nashville Intl", 
    city: "Nashville", state: "TN", lat: 36.1263, lon: -86.6774,
    hubSize: "medium", runwayLength: 11030, slotCostMult: 1.8,
    noiseRestrictions: "none", international: true
  },
  KSLC: { 
    icao: "KSLC", iata: "SLC", name: "Salt Lake City Intl", 
    city: "Salt Lake City", state: "UT", lat: 40.7899, lon: -111.979,
    hubSize: "medium", runwayLength: 12003, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },
  KMDW: { 
    icao: "KMDW", iata: "MDW", name: "Chicago Midway Intl", 
    city: "Chicago", state: "IL", lat: 41.7868, lon: -87.7522,
    hubSize: "medium", runwayLength: 6522, slotCostMult: 2.0,
    noiseRestrictions: "strict", international: false
  },
  KIAD: { 
    icao: "KIAD", iata: "IAD", name: "Washington Dulles Intl", 
    city: "Washington", state: "DC", lat: 38.9531, lon: -77.4565,
    hubSize: "medium", runwayLength: 11500, slotCostMult: 2.2,
    noiseRestrictions: "none", international: true
  },
  KHOU: { 
    icao: "KHOU", iata: "HOU", name: "William P. Hobby", 
    city: "Houston", state: "TX", lat: 29.6454, lon: -95.2789,
    hubSize: "medium", runwayLength: 7602, slotCostMult: 1.5,
    noiseRestrictions: "night_curfew", international: true
  },
  KPDX: { 
    icao: "KPDX", iata: "PDX", name: "Portland Intl", 
    city: "Portland", state: "OR", lat: 45.5898, lon: -122.598,
    hubSize: "medium", runwayLength: 11000, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },

  // ============================================================================
  // SMALL HUBS (20 airports)
  // ============================================================================

  KSTL: { 
    icao: "KSTL", iata: "STL", name: "St. Louis Lambert Intl", 
    city: "St. Louis", state: "MO", lat: 38.7487, lon: -90.3700,
    hubSize: "small", runwayLength: 11019, slotCostMult: 1.2,
    noiseRestrictions: "none", international: true
  },
  KMCI: { 
    icao: "KMCI", iata: "MCI", name: "Kansas City Intl", 
    city: "Kansas City", state: "MO", lat: 39.2976, lon: -94.7139,
    hubSize: "small", runwayLength: 10801, slotCostMult: 1.0,
    noiseRestrictions: "none", international: true
  },
  KRDU: { 
    icao: "KRDU", iata: "RDU", name: "Raleigh-Durham Intl", 
    city: "Raleigh", state: "NC", lat: 35.8801, lon: -78.7870,
    hubSize: "small", runwayLength: 10000, slotCostMult: 1.2,
    noiseRestrictions: "none", international: true
  },
  KCLT: { 
    icao: "KCLT", iata: "CLT", name: "Charlotte Douglas Intl", 
    city: "Charlotte", state: "NC", lat: 35.2140, lon: -80.9431,
    hubSize: "small", runwayLength: 10000, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },
  KBWI: { 
    icao: "KBWI", iata: "BWI", name: "Baltimore/Washington Intl", 
    city: "Baltimore", state: "MD", lat: 39.1754, lon: -76.6683,
    hubSize: "small", runwayLength: 10502, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },
  KCVG: { 
    icao: "KCVG", iata: "CVG", name: "Cincinnati/Northern Kentucky Intl", 
    city: "Cincinnati", state: "OH", lat: 39.0488, lon: -84.6678,
    hubSize: "small", runwayLength: 12000, slotCostMult: 1.0,
    noiseRestrictions: "none", international: true
  },
  KPIT: { 
    icao: "KPIT", iata: "PIT", name: "Pittsburgh Intl", 
    city: "Pittsburgh", state: "PA", lat: 40.4915, lon: -80.2329,
    hubSize: "small", runwayLength: 11500, slotCostMult: 1.0,
    noiseRestrictions: "none", international: true
  },
  KCLE: { 
    icao: "KCLE", iata: "CLE", name: "Cleveland Hopkins Intl", 
    city: "Cleveland", state: "OH", lat: 41.4117, lon: -81.8498,
    hubSize: "small", runwayLength: 9956, slotCostMult: 1.0,
    noiseRestrictions: "none", international: true
  },
  KIND: { 
    icao: "KIND", iata: "IND", name: "Indianapolis Intl", 
    city: "Indianapolis", state: "IN", lat: 39.7173, lon: -86.2944,
    hubSize: "small", runwayLength: 11200, slotCostMult: 1.0,
    noiseRestrictions: "none", international: true
  },
  KMKE: { 
    icao: "KMKE", iata: "MKE", name: "Milwaukee Mitchell Intl", 
    city: "Milwaukee", state: "WI", lat: 42.9472, lon: -87.8966,
    hubSize: "small", runwayLength: 9690, slotCostMult: 1.0,
    noiseRestrictions: "none", international: true
  },
  KSMF: { 
    icao: "KSMF", iata: "SMF", name: "Sacramento Intl", 
    city: "Sacramento", state: "CA", lat: 38.6954, lon: -121.591,
    hubSize: "small", runwayLength: 8600, slotCostMult: 1.0,
    noiseRestrictions: "night_curfew", international: true
  },
  KSJC: { 
    icao: "KSJC", iata: "SJC", name: "San Jose Intl", 
    city: "San Jose", state: "CA", lat: 37.3626, lon: -121.929,
    hubSize: "small", runwayLength: 11000, slotCostMult: 1.5,
    noiseRestrictions: "night_curfew", international: true
  },
  KOAK: { 
    icao: "KOAK", iata: "OAK", name: "Oakland Intl", 
    city: "Oakland", state: "CA", lat: 37.7213, lon: -122.221,
    hubSize: "small", runwayLength: 10520, slotCostMult: 1.2,
    noiseRestrictions: "night_curfew", international: true
  },
  KSNA: { 
    icao: "KSNA", iata: "SNA", name: "John Wayne Airport", 
    city: "Santa Ana", state: "CA", lat: 33.6757, lon: -117.868,
    hubSize: "small", runwayLength: 5701, slotCostMult: 2.0,
    noiseRestrictions: "strict", international: false
  },
  KSAT: { 
    icao: "KSAT", iata: "SAT", name: "San Antonio Intl", 
    city: "San Antonio", state: "TX", lat: 29.5337, lon: -98.4698,
    hubSize: "small", runwayLength: 8502, slotCostMult: 1.0,
    noiseRestrictions: "none", international: true
  },
  KOMA: { 
    icao: "KOMA", iata: "OMA", name: "Eppley Airfield", 
    city: "Omaha", state: "NE", lat: 41.3032, lon: -95.8941,
    hubSize: "small", runwayLength: 9502, slotCostMult: 0.8,
    noiseRestrictions: "none", international: false
  },
  KABQ: { 
    icao: "KABQ", iata: "ABQ", name: "Albuquerque Intl Sunport", 
    city: "Albuquerque", state: "NM", lat: 35.0402, lon: -106.609,
    hubSize: "small", runwayLength: 13793, slotCostMult: 0.8,
    noiseRestrictions: "none", international: true
  },
  KELP: { 
    icao: "KELP", iata: "ELP", name: "El Paso Intl", 
    city: "El Paso", state: "TX", lat: 31.8072, lon: -106.378,
    hubSize: "small", runwayLength: 12020, slotCostMult: 0.8,
    noiseRestrictions: "none", international: true
  },
  KTUS: { 
    icao: "KTUS", iata: "TUS", name: "Tucson Intl", 
    city: "Tucson", state: "AZ", lat: 32.1161, lon: -110.941,
    hubSize: "small", runwayLength: 10996, slotCostMult: 0.8,
    noiseRestrictions: "none", international: true
  },
  KBOI: { 
    icao: "KBOI", iata: "BOI", name: "Boise Air Terminal", 
    city: "Boise", state: "ID", lat: 43.5644, lon: -116.223,
    hubSize: "small", runwayLength: 10000, slotCostMult: 0.8,
    noiseRestrictions: "none", international: false
  },
  KRDM: {
    icao: "KRDM", iata: "RDM", name: "Redmond Municipal",
    city: "Redmond", state: "OR", lat: 44.2541, lon: -121.1500,
    hubSize: "small", runwayLength: 7038, slotCostMult: 0.8,
    noiseRestrictions: "none", international: false
  },

  // ============================================================================
  // CANADA
  // ============================================================================
  CYYZ: {
    icao: "CYYZ", iata: "YYZ", name: "Toronto Pearson Intl",
    city: "Toronto", country: "Canada", lat: 43.6777, lon: -79.6248,
    hubSize: "large", runwayLength: 11120, slotCostMult: 2.5,
    noiseRestrictions: "night_curfew", international: true
  },
  CYVR: {
    icao: "CYVR", iata: "YVR", name: "Vancouver Intl",
    city: "Vancouver", country: "Canada", lat: 49.1947, lon: -123.1792,
    hubSize: "large", runwayLength: 11500, slotCostMult: 2.2,
    noiseRestrictions: "night_curfew", international: true
  },
  CYUL: {
    icao: "CYUL", iata: "YUL", name: "Montreal-Trudeau Intl",
    city: "Montreal", country: "Canada", lat: 45.4706, lon: -73.7408,
    hubSize: "large", runwayLength: 11000, slotCostMult: 2.0,
    noiseRestrictions: "night_curfew", international: true
  },
  CYYC: {
    icao: "CYYC", iata: "YYC", name: "Calgary Intl",
    city: "Calgary", country: "Canada", lat: 51.1215, lon: -114.0076,
    hubSize: "medium", runwayLength: 14000, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },
  CYEG: {
    icao: "CYEG", iata: "YEG", name: "Edmonton Intl",
    city: "Edmonton", country: "Canada", lat: 53.3097, lon: -113.5797,
    hubSize: "medium", runwayLength: 11000, slotCostMult: 1.2,
    noiseRestrictions: "none", international: true
  },
  CYOW: {
    icao: "CYOW", iata: "YOW", name: "Ottawa Macdonald-Cartier Intl",
    city: "Ottawa", country: "Canada", lat: 45.3225, lon: -75.6692,
    hubSize: "medium", runwayLength: 10000, slotCostMult: 1.3,
    noiseRestrictions: "none", international: true
  },

  // ============================================================================
  // MEXICO & CENTRAL AMERICA
  // ============================================================================
  MMMX: {
    icao: "MMMX", iata: "MEX", name: "Mexico City Intl",
    city: "Mexico City", country: "Mexico", lat: 19.4363, lon: -99.0721,
    hubSize: "large", runwayLength: 12966, slotCostMult: 2.5,
    noiseRestrictions: "night_curfew", international: true
  },
  MMUN: {
    icao: "MMUN", iata: "CUN", name: "Cancun Intl",
    city: "Cancun", country: "Mexico", lat: 21.0365, lon: -86.8771,
    hubSize: "large", runwayLength: 11483, slotCostMult: 2.0,
    noiseRestrictions: "none", international: true
  },
  MMGL: {
    icao: "MMGL", iata: "GDL", name: "Guadalajara Intl",
    city: "Guadalajara", country: "Mexico", lat: 20.5218, lon: -103.3111,
    hubSize: "medium", runwayLength: 13123, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },
  MPTY: {
    icao: "MPTY", iata: "PTY", name: "Tocumen Intl",
    city: "Panama City", country: "Panama", lat: 9.0714, lon: -79.3835,
    hubSize: "large", runwayLength: 10006, slotCostMult: 2.0,
    noiseRestrictions: "none", international: true
  },
  MROC: {
    icao: "MROC", iata: "SJO", name: "Juan Santamaria Intl",
    city: "San Jose", country: "Costa Rica", lat: 9.9939, lon: -84.2088,
    hubSize: "medium", runwayLength: 9882, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },

  // ============================================================================
  // SOUTH AMERICA
  // ============================================================================
  SBGR: {
    icao: "SBGR", iata: "GRU", name: "São Paulo-Guarulhos Intl",
    city: "São Paulo", country: "Brazil", lat: -23.4356, lon: -46.4731,
    hubSize: "large", runwayLength: 12139, slotCostMult: 2.8,
    noiseRestrictions: "night_curfew", international: true
  },
  SBGL: {
    icao: "SBGL", iata: "GIG", name: "Rio de Janeiro-Galeão Intl",
    city: "Rio de Janeiro", country: "Brazil", lat: -22.8100, lon: -43.2506,
    hubSize: "large", runwayLength: 13123, slotCostMult: 2.2,
    noiseRestrictions: "none", international: true
  },
  SBBR: {
    icao: "SBBR", iata: "BSB", name: "Brasilia Intl",
    city: "Brasilia", country: "Brazil", lat: -15.8711, lon: -47.9186,
    hubSize: "medium", runwayLength: 10499, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },
  SAEZ: {
    icao: "SAEZ", iata: "EZE", name: "Buenos Aires-Ezeiza Intl",
    city: "Buenos Aires", country: "Argentina", lat: -34.8222, lon: -58.5358,
    hubSize: "large", runwayLength: 10827, slotCostMult: 2.5,
    noiseRestrictions: "night_curfew", international: true
  },
  SCEL: {
    icao: "SCEL", iata: "SCL", name: "Santiago Intl",
    city: "Santiago", country: "Chile", lat: -33.3930, lon: -70.7858,
    hubSize: "large", runwayLength: 12139, slotCostMult: 2.2,
    noiseRestrictions: "night_curfew", international: true
  },
  SKBO: {
    icao: "SKBO", iata: "BOG", name: "El Dorado Intl",
    city: "Bogota", country: "Colombia", lat: 4.7016, lon: -74.1469,
    hubSize: "large", runwayLength: 12467, slotCostMult: 2.2,
    noiseRestrictions: "none", international: true
  },
  SPJC: {
    icao: "SPJC", iata: "LIM", name: "Jorge Chavez Intl",
    city: "Lima", country: "Peru", lat: -12.0219, lon: -77.1143,
    hubSize: "large", runwayLength: 11506, slotCostMult: 2.0,
    noiseRestrictions: "none", international: true
  },
  SEQM: {
    icao: "SEQM", iata: "UIO", name: "Mariscal Sucre Intl",
    city: "Quito", country: "Ecuador", lat: -0.1292, lon: -78.3575,
    hubSize: "medium", runwayLength: 13451, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },
  SVMI: {
    icao: "SVMI", iata: "CCS", name: "Simon Bolivar Intl",
    city: "Caracas", country: "Venezuela", lat: 10.6012, lon: -66.9912,
    hubSize: "medium", runwayLength: 11483, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },

  // ============================================================================
  // ICELAND
  // ============================================================================
  BIKF: {
    icao: "BIKF", iata: "KEF", name: "Keflavik Intl",
    city: "Reykjavik", country: "Iceland", lat: 63.985, lon: -22.6056,
    hubSize: "medium", runwayLength: 10056, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },

  // ============================================================================
  // EUROPE - MAJOR HUBS
  // ============================================================================
  EGLL: {
    icao: "EGLL", iata: "LHR", name: "London Heathrow",
    city: "London", country: "United Kingdom", lat: 51.4700, lon: -0.4543,
    hubSize: "large", runwayLength: 12802, slotCostMult: 4.5,
    noiseRestrictions: "strict", international: true
  },
  EGKK: {
    icao: "EGKK", iata: "LGW", name: "London Gatwick",
    city: "London", country: "United Kingdom", lat: 51.1481, lon: -0.1903,
    hubSize: "large", runwayLength: 10879, slotCostMult: 3.0,
    noiseRestrictions: "strict", international: true
  },
  EGLC: {
    icao: "EGLC", iata: "LCY", name: "London City",
    city: "London", country: "United Kingdom", lat: 51.5053, lon: 0.0553,
    hubSize: "small", runwayLength: 4948, slotCostMult: 3.5,
    noiseRestrictions: "strict", international: true
  },
  EGSS: {
    icao: "EGSS", iata: "STN", name: "London Stansted",
    city: "London", country: "United Kingdom", lat: 51.8850, lon: 0.2350,
    hubSize: "medium", runwayLength: 10000, slotCostMult: 2.0,
    noiseRestrictions: "night_curfew", international: true
  },
  LFPG: {
    icao: "LFPG", iata: "CDG", name: "Paris Charles de Gaulle",
    city: "Paris", country: "France", lat: 49.0097, lon: 2.5479,
    hubSize: "large", runwayLength: 13829, slotCostMult: 4.0,
    noiseRestrictions: "night_curfew", international: true
  },
  LFPO: {
    icao: "LFPO", iata: "ORY", name: "Paris Orly",
    city: "Paris", country: "France", lat: 48.7262, lon: 2.3652,
    hubSize: "large", runwayLength: 11975, slotCostMult: 3.0,
    noiseRestrictions: "strict", international: true
  },
  EDDF: {
    icao: "EDDF", iata: "FRA", name: "Frankfurt am Main",
    city: "Frankfurt", country: "Germany", lat: 50.0379, lon: 8.5622,
    hubSize: "large", runwayLength: 13123, slotCostMult: 4.0,
    noiseRestrictions: "night_curfew", international: true
  },
  EDDM: {
    icao: "EDDM", iata: "MUC", name: "Munich",
    city: "Munich", country: "Germany", lat: 48.3537, lon: 11.7750,
    hubSize: "large", runwayLength: 13123, slotCostMult: 3.0,
    noiseRestrictions: "night_curfew", international: true
  },
  EDDB: {
    icao: "EDDB", iata: "BER", name: "Berlin Brandenburg",
    city: "Berlin", country: "Germany", lat: 52.3667, lon: 13.5033,
    hubSize: "large", runwayLength: 13123, slotCostMult: 2.5,
    noiseRestrictions: "night_curfew", international: true
  },
  EHAM: {
    icao: "EHAM", iata: "AMS", name: "Amsterdam Schiphol",
    city: "Amsterdam", country: "Netherlands", lat: 52.3086, lon: 4.7639,
    hubSize: "large", runwayLength: 12467, slotCostMult: 4.0,
    noiseRestrictions: "strict", international: true
  },
  LEMD: {
    icao: "LEMD", iata: "MAD", name: "Madrid-Barajas",
    city: "Madrid", country: "Spain", lat: 40.4983, lon: -3.5676,
    hubSize: "large", runwayLength: 14271, slotCostMult: 3.5,
    noiseRestrictions: "night_curfew", international: true
  },
  LEBL: {
    icao: "LEBL", iata: "BCN", name: "Barcelona-El Prat",
    city: "Barcelona", country: "Spain", lat: 41.2971, lon: 2.0785,
    hubSize: "large", runwayLength: 11654, slotCostMult: 3.0,
    noiseRestrictions: "night_curfew", international: true
  },
  LIRF: {
    icao: "LIRF", iata: "FCO", name: "Rome Fiumicino",
    city: "Rome", country: "Italy", lat: 41.8003, lon: 12.2389,
    hubSize: "large", runwayLength: 12795, slotCostMult: 3.5,
    noiseRestrictions: "night_curfew", international: true
  },
  LIMC: {
    icao: "LIMC", iata: "MXP", name: "Milan Malpensa",
    city: "Milan", country: "Italy", lat: 45.6306, lon: 8.7231,
    hubSize: "large", runwayLength: 12861, slotCostMult: 3.0,
    noiseRestrictions: "night_curfew", international: true
  },
  LSZH: {
    icao: "LSZH", iata: "ZRH", name: "Zurich",
    city: "Zurich", country: "Switzerland", lat: 47.4647, lon: 8.5492,
    hubSize: "large", runwayLength: 12139, slotCostMult: 3.5,
    noiseRestrictions: "strict", international: true
  },
  LOWW: {
    icao: "LOWW", iata: "VIE", name: "Vienna Intl",
    city: "Vienna", country: "Austria", lat: 48.1103, lon: 16.5697,
    hubSize: "large", runwayLength: 11811, slotCostMult: 3.0,
    noiseRestrictions: "night_curfew", international: true
  },
  EBBR: {
    icao: "EBBR", iata: "BRU", name: "Brussels",
    city: "Brussels", country: "Belgium", lat: 50.9014, lon: 4.4844,
    hubSize: "large", runwayLength: 11936, slotCostMult: 2.8,
    noiseRestrictions: "strict", international: true
  },
  EIDW: {
    icao: "EIDW", iata: "DUB", name: "Dublin",
    city: "Dublin", country: "Ireland", lat: 53.4213, lon: -6.2701,
    hubSize: "large", runwayLength: 10499, slotCostMult: 2.5,
    noiseRestrictions: "night_curfew", international: true
  },
  EKCH: {
    icao: "EKCH", iata: "CPH", name: "Copenhagen",
    city: "Copenhagen", country: "Denmark", lat: 55.6180, lon: 12.6508,
    hubSize: "large", runwayLength: 11811, slotCostMult: 3.0,
    noiseRestrictions: "night_curfew", international: true
  },
  ESSA: {
    icao: "ESSA", iata: "ARN", name: "Stockholm Arlanda",
    city: "Stockholm", country: "Sweden", lat: 59.6519, lon: 17.9186,
    hubSize: "large", runwayLength: 10827, slotCostMult: 2.8,
    noiseRestrictions: "night_curfew", international: true
  },
  ENGM: {
    icao: "ENGM", iata: "OSL", name: "Oslo Gardermoen",
    city: "Oslo", country: "Norway", lat: 60.1939, lon: 11.1004,
    hubSize: "large", runwayLength: 11811, slotCostMult: 2.5,
    noiseRestrictions: "night_curfew", international: true
  },
  EFHK: {
    icao: "EFHK", iata: "HEL", name: "Helsinki-Vantaa",
    city: "Helsinki", country: "Finland", lat: 60.3172, lon: 24.9633,
    hubSize: "large", runwayLength: 11286, slotCostMult: 2.5,
    noiseRestrictions: "night_curfew", international: true
  },
  LPPT: {
    icao: "LPPT", iata: "LIS", name: "Lisbon Portela",
    city: "Lisbon", country: "Portugal", lat: 38.7756, lon: -9.1354,
    hubSize: "large", runwayLength: 12484, slotCostMult: 2.5,
    noiseRestrictions: "night_curfew", international: true
  },
  LGAV: {
    icao: "LGAV", iata: "ATH", name: "Athens Intl",
    city: "Athens", country: "Greece", lat: 37.9364, lon: 23.9445,
    hubSize: "large", runwayLength: 13123, slotCostMult: 2.5,
    noiseRestrictions: "none", international: true
  },
  LTFM: {
    icao: "LTFM", iata: "IST", name: "Istanbul",
    city: "Istanbul", country: "Turkey", lat: 41.2753, lon: 28.7519,
    hubSize: "large", runwayLength: 13451, slotCostMult: 3.0,
    noiseRestrictions: "none", international: true
  },
  UUEE: {
    icao: "UUEE", iata: "SVO", name: "Moscow Sheremetyevo",
    city: "Moscow", country: "Russia", lat: 55.9726, lon: 37.4146,
    hubSize: "large", runwayLength: 12139, slotCostMult: 3.0,
    noiseRestrictions: "none", international: true
  },
  ULLI: {
    icao: "ULLI", iata: "LED", name: "St Petersburg Pulkovo",
    city: "St Petersburg", country: "Russia", lat: 59.8003, lon: 30.2625,
    hubSize: "large", runwayLength: 11483, slotCostMult: 2.0,
    noiseRestrictions: "none", international: true
  },
  EPWA: {
    icao: "EPWA", iata: "WAW", name: "Warsaw Chopin",
    city: "Warsaw", country: "Poland", lat: 52.1657, lon: 20.9671,
    hubSize: "large", runwayLength: 11811, slotCostMult: 2.2,
    noiseRestrictions: "night_curfew", international: true
  },
  LKPR: {
    icao: "LKPR", iata: "PRG", name: "Prague Vaclav Havel",
    city: "Prague", country: "Czech Republic", lat: 50.1008, lon: 14.2600,
    hubSize: "large", runwayLength: 12191, slotCostMult: 2.0,
    noiseRestrictions: "night_curfew", international: true
  },
  LHBP: {
    icao: "LHBP", iata: "BUD", name: "Budapest Ferenc Liszt",
    city: "Budapest", country: "Hungary", lat: 47.4369, lon: 19.2556,
    hubSize: "medium", runwayLength: 12162, slotCostMult: 1.8,
    noiseRestrictions: "night_curfew", international: true
  },

  // ============================================================================
  // MIDDLE EAST
  // ============================================================================
  OMDB: {
    icao: "OMDB", iata: "DXB", name: "Dubai Intl",
    city: "Dubai", country: "UAE", lat: 25.2532, lon: 55.3657,
    hubSize: "large", runwayLength: 14272, slotCostMult: 4.0,
    noiseRestrictions: "none", international: true
  },
  OMDW: {
    icao: "OMDW", iata: "DWC", name: "Dubai World Central",
    city: "Dubai", country: "UAE", lat: 24.8964, lon: 55.1614,
    hubSize: "large", runwayLength: 14764, slotCostMult: 2.5,
    noiseRestrictions: "none", international: true
  },
  OMAA: {
    icao: "OMAA", iata: "AUH", name: "Abu Dhabi Intl",
    city: "Abu Dhabi", country: "UAE", lat: 24.4331, lon: 54.6511,
    hubSize: "large", runwayLength: 13451, slotCostMult: 3.5,
    noiseRestrictions: "none", international: true
  },
  OTHH: {
    icao: "OTHH", iata: "DOH", name: "Hamad Intl",
    city: "Doha", country: "Qatar", lat: 25.2731, lon: 51.6081,
    hubSize: "large", runwayLength: 15912, slotCostMult: 4.0,
    noiseRestrictions: "none", international: true
  },
  OEJN: {
    icao: "OEJN", iata: "JED", name: "King Abdulaziz Intl",
    city: "Jeddah", country: "Saudi Arabia", lat: 21.6796, lon: 39.1565,
    hubSize: "large", runwayLength: 12467, slotCostMult: 2.5,
    noiseRestrictions: "none", international: true
  },
  OERK: {
    icao: "OERK", iata: "RUH", name: "King Khalid Intl",
    city: "Riyadh", country: "Saudi Arabia", lat: 24.9578, lon: 46.6989,
    hubSize: "large", runwayLength: 13780, slotCostMult: 2.5,
    noiseRestrictions: "none", international: true
  },
  LLBG: {
    icao: "LLBG", iata: "TLV", name: "Ben Gurion Intl",
    city: "Tel Aviv", country: "Israel", lat: 32.0114, lon: 34.8867,
    hubSize: "large", runwayLength: 11998, slotCostMult: 3.0,
    noiseRestrictions: "night_curfew", international: true
  },
  OIIE: {
    icao: "OIIE", iata: "IKA", name: "Tehran Imam Khomeini",
    city: "Tehran", country: "Iran", lat: 35.4161, lon: 51.1522,
    hubSize: "large", runwayLength: 13780, slotCostMult: 2.0,
    noiseRestrictions: "none", international: true
  },
  OKBK: {
    icao: "OKBK", iata: "KWI", name: "Kuwait Intl",
    city: "Kuwait City", country: "Kuwait", lat: 29.2267, lon: 47.9689,
    hubSize: "medium", runwayLength: 11155, slotCostMult: 2.0,
    noiseRestrictions: "none", international: true
  },
  OBBI: {
    icao: "OBBI", iata: "BAH", name: "Bahrain Intl",
    city: "Manama", country: "Bahrain", lat: 26.2708, lon: 50.6336,
    hubSize: "medium", runwayLength: 13002, slotCostMult: 2.0,
    noiseRestrictions: "none", international: true
  },
  OOMS: {
    icao: "OOMS", iata: "MCT", name: "Muscat Intl",
    city: "Muscat", country: "Oman", lat: 23.5933, lon: 58.2844,
    hubSize: "medium", runwayLength: 13123, slotCostMult: 1.8,
    noiseRestrictions: "none", international: true
  },
  OJAM: {
    icao: "OJAM", iata: "AMM", name: "Queen Alia Intl",
    city: "Amman", country: "Jordan", lat: 31.7226, lon: 35.9932,
    hubSize: "medium", runwayLength: 12008, slotCostMult: 1.8,
    noiseRestrictions: "none", international: true
  },

  // ============================================================================
  // ASIA - EAST ASIA
  // ============================================================================
  RJTT: {
    icao: "RJTT", iata: "HND", name: "Tokyo Haneda",
    city: "Tokyo", country: "Japan", lat: 35.5494, lon: 139.7798,
    hubSize: "large", runwayLength: 11024, slotCostMult: 4.5,
    noiseRestrictions: "strict", international: true
  },
  RJAA: {
    icao: "RJAA", iata: "NRT", name: "Tokyo Narita",
    city: "Tokyo", country: "Japan", lat: 35.7647, lon: 140.3864,
    hubSize: "large", runwayLength: 13123, slotCostMult: 3.5,
    noiseRestrictions: "strict", international: true
  },
  RJBB: {
    icao: "RJBB", iata: "KIX", name: "Osaka Kansai",
    city: "Osaka", country: "Japan", lat: 34.4347, lon: 135.2441,
    hubSize: "large", runwayLength: 13123, slotCostMult: 3.0,
    noiseRestrictions: "night_curfew", international: true
  },
  RKSI: {
    icao: "RKSI", iata: "ICN", name: "Seoul Incheon",
    city: "Seoul", country: "South Korea", lat: 37.4691, lon: 126.4505,
    hubSize: "large", runwayLength: 13123, slotCostMult: 3.5,
    noiseRestrictions: "night_curfew", international: true
  },
  RKSS: {
    icao: "RKSS", iata: "GMP", name: "Seoul Gimpo",
    city: "Seoul", country: "South Korea", lat: 37.5583, lon: 126.7906,
    hubSize: "large", runwayLength: 11811, slotCostMult: 3.0,
    noiseRestrictions: "night_curfew", international: true
  },
  ZBAA: {
    icao: "ZBAA", iata: "PEK", name: "Beijing Capital",
    city: "Beijing", country: "China", lat: 40.0799, lon: 116.6031,
    hubSize: "large", runwayLength: 12467, slotCostMult: 4.0,
    noiseRestrictions: "night_curfew", international: true
  },
  ZSPD: {
    icao: "ZSPD", iata: "PVG", name: "Shanghai Pudong",
    city: "Shanghai", country: "China", lat: 31.1434, lon: 121.8052,
    hubSize: "large", runwayLength: 13123, slotCostMult: 4.0,
    noiseRestrictions: "night_curfew", international: true
  },
  ZSSS: {
    icao: "ZSSS", iata: "SHA", name: "Shanghai Hongqiao",
    city: "Shanghai", country: "China", lat: 31.1979, lon: 121.3363,
    hubSize: "large", runwayLength: 10499, slotCostMult: 3.5,
    noiseRestrictions: "night_curfew", international: true
  },
  ZGGG: {
    icao: "ZGGG", iata: "CAN", name: "Guangzhou Baiyun",
    city: "Guangzhou", country: "China", lat: 23.3924, lon: 113.2988,
    hubSize: "large", runwayLength: 12467, slotCostMult: 3.0,
    noiseRestrictions: "none", international: true
  },
  VHHH: {
    icao: "VHHH", iata: "HKG", name: "Hong Kong Intl",
    city: "Hong Kong", country: "China", lat: 22.3080, lon: 113.9185,
    hubSize: "large", runwayLength: 12467, slotCostMult: 4.5,
    noiseRestrictions: "night_curfew", international: true
  },
  RCTP: {
    icao: "RCTP", iata: "TPE", name: "Taiwan Taoyuan",
    city: "Taipei", country: "Taiwan", lat: 25.0777, lon: 121.2329,
    hubSize: "large", runwayLength: 12008, slotCostMult: 3.0,
    noiseRestrictions: "night_curfew", international: true
  },

  // ============================================================================
  // ASIA - SOUTHEAST ASIA
  // ============================================================================
  WSSS: {
    icao: "WSSS", iata: "SIN", name: "Singapore Changi",
    city: "Singapore", country: "Singapore", lat: 1.3644, lon: 103.9915,
    hubSize: "large", runwayLength: 13123, slotCostMult: 4.5,
    noiseRestrictions: "night_curfew", international: true
  },
  WMKK: {
    icao: "WMKK", iata: "KUL", name: "Kuala Lumpur Intl",
    city: "Kuala Lumpur", country: "Malaysia", lat: 2.7456, lon: 101.7072,
    hubSize: "large", runwayLength: 13435, slotCostMult: 2.5,
    noiseRestrictions: "none", international: true
  },
  VTBS: {
    icao: "VTBS", iata: "BKK", name: "Bangkok Suvarnabhumi",
    city: "Bangkok", country: "Thailand", lat: 13.6900, lon: 100.7501,
    hubSize: "large", runwayLength: 13123, slotCostMult: 3.0,
    noiseRestrictions: "none", international: true
  },
  WIII: {
    icao: "WIII", iata: "CGK", name: "Jakarta Soekarno-Hatta",
    city: "Jakarta", country: "Indonesia", lat: -6.1256, lon: 106.6559,
    hubSize: "large", runwayLength: 12008, slotCostMult: 2.5,
    noiseRestrictions: "none", international: true
  },
  RPLL: {
    icao: "RPLL", iata: "MNL", name: "Manila Ninoy Aquino",
    city: "Manila", country: "Philippines", lat: 14.5086, lon: 121.0197,
    hubSize: "large", runwayLength: 11879, slotCostMult: 2.5,
    noiseRestrictions: "none", international: true
  },
  VVNB: {
    icao: "VVNB", iata: "HAN", name: "Hanoi Noi Bai",
    city: "Hanoi", country: "Vietnam", lat: 21.2212, lon: 105.8072,
    hubSize: "large", runwayLength: 12467, slotCostMult: 2.0,
    noiseRestrictions: "none", international: true
  },
  VVTS: {
    icao: "VVTS", iata: "SGN", name: "Ho Chi Minh Tan Son Nhat",
    city: "Ho Chi Minh City", country: "Vietnam", lat: 10.8188, lon: 106.6520,
    hubSize: "large", runwayLength: 10499, slotCostMult: 2.0,
    noiseRestrictions: "none", international: true
  },

  // ============================================================================
  // ASIA - SOUTH ASIA
  // ============================================================================
  VIDP: {
    icao: "VIDP", iata: "DEL", name: "Delhi Indira Gandhi",
    city: "New Delhi", country: "India", lat: 28.5562, lon: 77.1000,
    hubSize: "large", runwayLength: 14534, slotCostMult: 3.0,
    noiseRestrictions: "night_curfew", international: true
  },
  VABB: {
    icao: "VABB", iata: "BOM", name: "Mumbai Chhatrapati Shivaji",
    city: "Mumbai", country: "India", lat: 19.0896, lon: 72.8656,
    hubSize: "large", runwayLength: 12008, slotCostMult: 3.0,
    noiseRestrictions: "night_curfew", international: true
  },
  VOBL: {
    icao: "VOBL", iata: "BLR", name: "Bangalore Kempegowda",
    city: "Bangalore", country: "India", lat: 13.1979, lon: 77.7063,
    hubSize: "large", runwayLength: 13123, slotCostMult: 2.5,
    noiseRestrictions: "none", international: true
  },
  VOMM: {
    icao: "VOMM", iata: "MAA", name: "Chennai Intl",
    city: "Chennai", country: "India", lat: 12.9941, lon: 80.1709,
    hubSize: "large", runwayLength: 12001, slotCostMult: 2.0,
    noiseRestrictions: "none", international: true
  },
  VCBI: {
    icao: "VCBI", iata: "CMB", name: "Colombo Bandaranaike",
    city: "Colombo", country: "Sri Lanka", lat: 7.1808, lon: 79.8841,
    hubSize: "medium", runwayLength: 10990, slotCostMult: 1.8,
    noiseRestrictions: "none", international: true
  },
  VRMM: {
    icao: "VRMM", iata: "MLE", name: "Male Velana Intl",
    city: "Male", country: "Maldives", lat: 4.1918, lon: 73.5291,
    hubSize: "medium", runwayLength: 10499, slotCostMult: 2.0,
    noiseRestrictions: "none", international: true
  },
  OPKC: {
    icao: "OPKC", iata: "KHI", name: "Karachi Jinnah Intl",
    city: "Karachi", country: "Pakistan", lat: 24.9065, lon: 67.1608,
    hubSize: "large", runwayLength: 11155, slotCostMult: 1.8,
    noiseRestrictions: "none", international: true
  },
  VNKT: {
    icao: "VNKT", iata: "KTM", name: "Kathmandu Tribhuvan",
    city: "Kathmandu", country: "Nepal", lat: 27.6966, lon: 85.3591,
    hubSize: "medium", runwayLength: 10007, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },
  VGHS: {
    icao: "VGHS", iata: "DAC", name: "Dhaka Hazrat Shahjalal",
    city: "Dhaka", country: "Bangladesh", lat: 23.8433, lon: 90.3978,
    hubSize: "medium", runwayLength: 10500, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },

  // ============================================================================
  // AFRICA
  // ============================================================================
  FAOR: {
    icao: "FAOR", iata: "JNB", name: "Johannesburg OR Tambo",
    city: "Johannesburg", country: "South Africa", lat: -26.1392, lon: 28.2460,
    hubSize: "large", runwayLength: 14495, slotCostMult: 2.5,
    noiseRestrictions: "night_curfew", international: true
  },
  FACT: {
    icao: "FACT", iata: "CPT", name: "Cape Town Intl",
    city: "Cape Town", country: "South Africa", lat: -33.9715, lon: 18.6021,
    hubSize: "large", runwayLength: 10502, slotCostMult: 2.0,
    noiseRestrictions: "night_curfew", international: true
  },
  HECA: {
    icao: "HECA", iata: "CAI", name: "Cairo Intl",
    city: "Cairo", country: "Egypt", lat: 30.1219, lon: 31.4056,
    hubSize: "large", runwayLength: 13123, slotCostMult: 2.5,
    noiseRestrictions: "none", international: true
  },
  GMMN: {
    icao: "GMMN", iata: "CMN", name: "Casablanca Mohammed V",
    city: "Casablanca", country: "Morocco", lat: 33.3675, lon: -7.5900,
    hubSize: "large", runwayLength: 12205, slotCostMult: 2.0,
    noiseRestrictions: "none", international: true
  },
  HKJK: {
    icao: "HKJK", iata: "NBO", name: "Nairobi Jomo Kenyatta",
    city: "Nairobi", country: "Kenya", lat: -1.3192, lon: 36.9278,
    hubSize: "large", runwayLength: 13507, slotCostMult: 2.0,
    noiseRestrictions: "none", international: true
  },
  HAAB: {
    icao: "HAAB", iata: "ADD", name: "Addis Ababa Bole",
    city: "Addis Ababa", country: "Ethiopia", lat: 8.9779, lon: 38.7993,
    hubSize: "large", runwayLength: 12467, slotCostMult: 2.0,
    noiseRestrictions: "none", international: true
  },
  DNMM: {
    icao: "DNMM", iata: "LOS", name: "Lagos Murtala Muhammed",
    city: "Lagos", country: "Nigeria", lat: 6.5774, lon: 3.3212,
    hubSize: "large", runwayLength: 12795, slotCostMult: 1.8,
    noiseRestrictions: "none", international: true
  },
  DTTA: {
    icao: "DTTA", iata: "TUN", name: "Tunis-Carthage",
    city: "Tunis", country: "Tunisia", lat: 36.8510, lon: 10.2272,
    hubSize: "medium", runwayLength: 10499, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },
  DAAG: {
    icao: "DAAG", iata: "ALG", name: "Algiers Houari Boumediene",
    city: "Algiers", country: "Algeria", lat: 36.6910, lon: 3.2154,
    hubSize: "medium", runwayLength: 11483, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },
  FMMI: {
    icao: "FMMI", iata: "TNR", name: "Antananarivo Ivato",
    city: "Antananarivo", country: "Madagascar", lat: -18.7969, lon: 47.4789,
    hubSize: "medium", runwayLength: 10171, slotCostMult: 1.2,
    noiseRestrictions: "none", international: true
  },
  FIMP: {
    icao: "FIMP", iata: "MRU", name: "Mauritius Sir S. Ramgoolam",
    city: "Port Louis", country: "Mauritius", lat: -20.4302, lon: 57.6836,
    hubSize: "medium", runwayLength: 11401, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },

  // ============================================================================
  // OCEANIA
  // ============================================================================
  YSSY: {
    icao: "YSSY", iata: "SYD", name: "Sydney Kingsford Smith",
    city: "Sydney", country: "Australia", lat: -33.9461, lon: 151.1772,
    hubSize: "large", runwayLength: 12999, slotCostMult: 3.5,
    noiseRestrictions: "strict", international: true
  },
  YMML: {
    icao: "YMML", iata: "MEL", name: "Melbourne Tullamarine",
    city: "Melbourne", country: "Australia", lat: -37.6733, lon: 144.8433,
    hubSize: "large", runwayLength: 12000, slotCostMult: 3.0,
    noiseRestrictions: "night_curfew", international: true
  },
  YBBN: {
    icao: "YBBN", iata: "BNE", name: "Brisbane Intl",
    city: "Brisbane", country: "Australia", lat: -27.3842, lon: 153.1175,
    hubSize: "large", runwayLength: 11483, slotCostMult: 2.5,
    noiseRestrictions: "night_curfew", international: true
  },
  YPPH: {
    icao: "YPPH", iata: "PER", name: "Perth Intl",
    city: "Perth", country: "Australia", lat: -31.9403, lon: 115.9672,
    hubSize: "large", runwayLength: 11299, slotCostMult: 2.0,
    noiseRestrictions: "night_curfew", international: true
  },
  NZAA: {
    icao: "NZAA", iata: "AKL", name: "Auckland Intl",
    city: "Auckland", country: "New Zealand", lat: -37.0082, lon: 174.7850,
    hubSize: "large", runwayLength: 11926, slotCostMult: 2.5,
    noiseRestrictions: "night_curfew", international: true
  },
  NZWN: {
    icao: "NZWN", iata: "WLG", name: "Wellington Intl",
    city: "Wellington", country: "New Zealand", lat: -41.3272, lon: 174.8053,
    hubSize: "medium", runwayLength: 6351, slotCostMult: 1.8,
    noiseRestrictions: "night_curfew", international: true
  },
  NZCH: {
    icao: "NZCH", iata: "CHC", name: "Christchurch Intl",
    city: "Christchurch", country: "New Zealand", lat: -43.4894, lon: 172.5322,
    hubSize: "medium", runwayLength: 10787, slotCostMult: 1.5,
    noiseRestrictions: "night_curfew", international: true
  },
  NFFN: {
    icao: "NFFN", iata: "NAN", name: "Nadi Intl",
    city: "Nadi", country: "Fiji", lat: -17.7554, lon: 177.4431,
    hubSize: "medium", runwayLength: 10500, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },
  PHNL: {
    icao: "PHNL", iata: "HNL", name: "Honolulu Daniel K. Inouye",
    city: "Honolulu", country: "USA", lat: 21.3187, lon: -157.9225,
    hubSize: "large", runwayLength: 12357, slotCostMult: 2.5,
    noiseRestrictions: "night_curfew", international: true
  },
  PGUM: {
    icao: "PGUM", iata: "GUM", name: "Guam Antonio B. Won Pat",
    city: "Hagatna", country: "Guam", lat: 13.4834, lon: 144.7959,
    hubSize: "medium", runwayLength: 10015, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },

  // ============================================================================
  // CARIBBEAN
  // ============================================================================
  TNCM: {
    icao: "TNCM", iata: "SXM", name: "Princess Juliana Intl",
    city: "St Maarten", country: "Sint Maarten", lat: 18.0410, lon: -63.1089,
    hubSize: "medium", runwayLength: 7546, slotCostMult: 1.8,
    noiseRestrictions: "none", international: true
  },
  TJSJ: {
    icao: "TJSJ", iata: "SJU", name: "San Juan Luis Munoz Marin",
    city: "San Juan", country: "Puerto Rico", lat: 18.4394, lon: -66.0018,
    hubSize: "large", runwayLength: 10002, slotCostMult: 2.0,
    noiseRestrictions: "none", international: true
  },
  MKJP: {
    icao: "MKJP", iata: "KIN", name: "Kingston Norman Manley",
    city: "Kingston", country: "Jamaica", lat: 17.9357, lon: -76.7875,
    hubSize: "medium", runwayLength: 8911, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },
  TBPB: {
    icao: "TBPB", iata: "BGI", name: "Barbados Grantley Adams",
    city: "Bridgetown", country: "Barbados", lat: 13.0746, lon: -59.4925,
    hubSize: "medium", runwayLength: 11000, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },
  MUHA: {
    icao: "MUHA", iata: "HAV", name: "Havana Jose Marti",
    city: "Havana", country: "Cuba", lat: 22.9892, lon: -82.4091,
    hubSize: "large", runwayLength: 13123, slotCostMult: 1.8,
    noiseRestrictions: "none", international: true
  },
  MDSD: {
    icao: "MDSD", iata: "SDQ", name: "Santo Domingo Las Americas",
    city: "Santo Domingo", country: "Dominican Republic", lat: 18.4297, lon: -69.6689,
    hubSize: "large", runwayLength: 11000, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },
  MYNN: {
    icao: "MYNN", iata: "NAS", name: "Nassau Lynden Pindling",
    city: "Nassau", country: "Bahamas", lat: 25.0390, lon: -77.4662,
    hubSize: "medium", runwayLength: 11000, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },
  TFFR: {
    icao: "TFFR", iata: "PTP", name: "Pointe-a-Pitre Le Raizet",
    city: "Pointe-a-Pitre", country: "Guadeloupe", lat: 16.2653, lon: -61.5318,
    hubSize: "medium", runwayLength: 11499, slotCostMult: 1.5,
    noiseRestrictions: "none", international: true
  },

  // ============================================================================
  // ALASKA
  // ============================================================================
  PANC: {
    icao: "PANC", iata: "ANC", name: "Anchorage Ted Stevens",
    city: "Anchorage", country: "USA", lat: 61.1744, lon: -149.9964,
    hubSize: "large", runwayLength: 12400, slotCostMult: 1.8,
    noiseRestrictions: "none", international: true
  },
  PAFA: {
    icao: "PAFA", iata: "FAI", name: "Fairbanks Intl",
    city: "Fairbanks", country: "USA", lat: 64.8151, lon: -147.8561,
    hubSize: "medium", runwayLength: 10300, slotCostMult: 1.2,
    noiseRestrictions: "none", international: true
  },
};

// Helper functions
export function getAirportByCode(code) {
  return AIRPORTS[code] || AIRPORTS[`K${code}`] || null;
}

export function getAirportsByHubSize(size) {
  return Object.entries(AIRPORTS)
    .filter(([_, apt]) => apt.hubSize === size)
    .map(([code, apt]) => ({ code, ...apt }));
}

export function getLargeHubs() {
  return getAirportsByHubSize("large");
}

export function getMediumHubs() {
  return getAirportsByHubSize("medium");
}

export function getSmallHubs() {
  return getAirportsByHubSize("small");
}

export function getAllAirports() {
  return Object.entries(AIRPORTS).map(([code, apt]) => ({ code, ...apt }));
}

// Helper to extract ICAO code from string or airport object
const toIcaoCode = (x) => {
  if (!x) return null;
  if (typeof x === "string") return x.toUpperCase();
  const code = x.icao || x.ICAO || x.code || x.id || null;
  return typeof code === "string" ? code.toUpperCase() : null;
};

// Calculate distance between airports (nm)
// Accepts ICAO codes (strings) OR airport objects - bulletproof against bad input
// Returns NaN if airports not found (never silently returns 0)
export function calculateDistance(origin, destination) {
  const oCode = toIcaoCode(origin);
  const dCode = toIcaoCode(destination);

  if (!oCode || !dCode) {
    console.warn('[calculateDistance] Invalid input:', { origin, destination });
    return NaN;
  }

  // Check limited AIRPORTS first, then FULL_AIRPORTS, then GLOBAL_AIRPORTS (user routes)
  const orig = AIRPORTS[oCode] || FULL_AIRPORTS[oCode] || GLOBAL_AIRPORTS[oCode];
  const dest = AIRPORTS[dCode] || FULL_AIRPORTS[dCode] || GLOBAL_AIRPORTS[dCode];

  if (!orig || !dest) {
    console.warn('[calculateDistance] Airport not found:', { oCode, dCode, origFound: !!orig, destFound: !!dest });
    return NaN;
  }

  // Validate that airports have lat/lon coordinates
  if (typeof orig.lat !== 'number' || typeof orig.lon !== 'number' ||
      typeof dest.lat !== 'number' || typeof dest.lon !== 'number') {
    console.warn('[calculateDistance] Airport missing coordinates:', { oCode, dCode, origLat: orig.lat, destLat: dest.lat });
    return NaN;
  }

  // Same origin and destination - zero distance route
  if (oCode === dCode) {
    console.warn('[calculateDistance] Same origin and destination:', oCode);
    return 0;
  }

  const R = 3440.065; // Earth radius in nautical miles
  const dLat = ((dest.lat - orig.lat) * Math.PI) / 180;
  const dLon = ((dest.lon - orig.lon) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((orig.lat * Math.PI) / 180) *
    Math.cos((dest.lat * Math.PI) / 180) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = Math.round(R * c);

  // Final sanity check
  if (!Number.isFinite(distance) || distance <= 0) {
    console.warn('[calculateDistance] Invalid result:', { oCode, dCode, distance });
    return NaN;
  }

  return distance;
}

export default AIRPORTS;
